import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getReportsFinanceByServices(companyId, query) {
  return dataTransferWrap(
    ModulesMap.REPORTS_FINANCE_BY_SERVICES,dtConfig[ModulesMap.REPORTS_FINANCE_BY_SERVICES].getReportsFinanceByServices,
    {
      urlParams: {
        companyId: companyId,
      },
      params: query,
    },
  )
}

export default {
  getReportsFinanceByServices
}